import React, { FC } from "react";
import { Modal as RBModal } from "react-bootstrap";
import Button from "../Button";
import { KitchenModalProps } from "./Modal.props";
import "./style.scss";

const Modal: FC<KitchenModalProps> = ({
    show,
    title,
    text,
    showCloseIcon,
    confirmBtnText,
    closeBtnText,
    withBorder = false,
    handleCloseModal,
    handleHideModal,
    handleSave,
    confirmBtnClass,
    isGreen,
}) => {
    return (
        <RBModal
            show={show}
            dir="rtl"
            centered
            onHide={handleHideModal || handleCloseModal}
            data-testid="Modal"
            style={{ minWidth: "388px"}}
        >
            <RBModal.Header
                className={withBorder ? "" : "border-0"}
                closeButton={showCloseIcon}
                onClick={handleCloseModal}
            >
                <RBModal.Title data-testid="Modal__title">
                    {title}
                </RBModal.Title>
            </RBModal.Header>
            {!Array.isArray(text) ? (
                <RBModal.Body data-testid="Modal__body">
                    <span className="px-2" style={{ fontWeight: "500", display: "block" }}>
                        {text}
                    </span>
                </RBModal.Body>
            ) : (
                <RBModal.Body data-testid="Modal__body">
                    {text?.map((el) => (
                        <span className="d-block mb-2" key={el}>
                            {el}
                        </span>
                    ))}
                </RBModal.Body>
            )}
            <RBModal.Footer
                className="border-0 flex-nowrap"
                data-testid="Modal__footer"
            >
                <Button
                    className={`${
                        isGreen ? "is-green" : "is-red"
                    } solid font-weight-normal is-half-height big ${
                        !handleCloseModal && "w-100"
                    } ${confirmBtnClass}`}
                    btnText={confirmBtnText}
                    handleClick={handleSave}
                />
                {handleCloseModal && (
                    <Button
                        className={`${
                            isGreen ? "is-green" : "is-red"
                        } bordered font-weight-normal is-half-height big`}
                        btnText={closeBtnText}
                        handleClick={handleCloseModal}
                    />
                )}
            </RBModal.Footer>
        </RBModal>
    );
};

export default Modal;
